import { OrgBaseInterface } from "../Shared/OrgBase.Interace";
import { SpotData } from "../Spot/Spot.Interfaces";

//LINK libs/entities/src/Brand/Brand.Entity.ts
export interface BrandInterface extends OrgBaseInterface {
  name: string;
  theme: Partial<BrandThemeInterface>;
  avatarURL?: string;
  isDefault: boolean;
  spotSlug: string;
  spotLinkSlug: string;
  /**
   * The 2-color brand model (ENG-2893): populated org-by-org by the Snowy
   * migrator (derived from `theme.primaryBackground`/`secondaryBackground`),
   * null until that org migrates. Consumers (ENG-3200) must fall back to the
   * legacy `theme` fields while this is null. Legacy `theme` is untouched.
   */
  colors?: BrandColorsInterface | null;
}

export interface BrandColorsInterface {
  primary: string;
  secondary: string;
}

export interface BrandThemeInterface {
  headerColor: string;
  headerBackground: string;

  text: string;
  textBackground: string;

  userBubbleBackground: string;
  userBubbleText: string;

  botBubbleBackground: string;
  botBubbleText: string;

  primaryBackground: string;
  primaryText: string;
  primaryHover: string;
  primaryHoverText: string;
  primaryActive: string;
  primaryActiveText: string;

  secondaryBackground: string;
  secondaryText: string;
  secondaryHover: string;
  secondaryHoverText: string;
  secondaryActive: string;
  secondaryActiveText: string;
}

export const DefaultTheme: BrandThemeInterface = {
  headerColor: "#000000",
  headerBackground: "#FFFFFF",

  text: "#000000",
  textBackground: "#FFFFFF",
  userBubbleBackground: "#F5F5F5",
  userBubbleText: "#000000",
  botBubbleBackground: "#FFEFE6",
  botBubbleText: "#000000",

  primaryBackground: "#FF5C02",
  primaryText: "#FFFFFF",
  primaryHover: "#000000",
  primaryHoverText: "#FFFFFF",
  primaryActive: "#FF5C02",
  primaryActiveText: "#FFFFFF",

  secondaryBackground: "#FF5C02",
  secondaryText: "#4B4B4B",
  secondaryHover: "#000000",
  secondaryHoverText: "#FFFFFF",
  secondaryActive: "#FF5C02",
  secondaryActiveText: "#FFFFFF"
};

export const DefaultBrand: Omit<BrandInterface, "createdAt" | "updatedAt"> = {
  theme: DefaultTheme,
  name: "",
  isDefault: false,
  spotSlug: "",
  spotLinkSlug: "",
  id: 0,
  orgId: 0
};
export function ColorForBrand(brand: BrandInterface, colorName: keyof BrandThemeInterface): string {
  if (brand.theme[colorName]) {
    return brand.theme[colorName]!;
  }
  return DefaultTheme[colorName] || "#000000";
}
export function ColorForBrandWithInheritance(brand: BrandInterface, colorName: keyof BrandThemeInterface) {
  if (brand.theme[colorName]) {
    return { color: brand.theme[colorName], inherited: false };
  }
  return { color: DefaultTheme[colorName], inherited: true };
}
